// Supabase Service - Centralized Supabase client for A2AMyEditorAI
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://eximyshafkuyehkiotuf.supabase.co';
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImV4aW15c2hhZmt1eWVoa2lvdHVmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTUxODc0MDEsImV4cCI6MjA3MDc2MzQwMX0.bjrI5MO_WUfnI53UaQ_m8BS8LPh2et5OrqMKmWUvYzw';

// Create singleton Supabase client to avoid multiple GoTrueClient instances
const supabase = createClient(supabaseUrl, supabaseKey);

// Expose to window for debugging (development only)
if (process.env.NODE_ENV === 'development' && typeof window !== 'undefined') {
  window.supabase = supabase;
  window.debugAnimationData = async () => {
    console.log('🔍 Debugging Triangle Centers Animation Data...');
    const { data, error } = await supabase
      .from('wysiwyg_sample_animations')
      .select('id, title, updated_at, animation_data')
      .eq('category', 'educational')
      .eq('example_number', 9)
      .single();
    
    if (error) {
      console.error('❌ Error:', error);
      return;
    }
    
    if (!data) {
      console.error('❌ No data found');
      return;
    }
    
    console.log('✅ Animation found:', {
      id: data.id,
      title: data.title,
      updated_at: data.updated_at
    });
    
    const animData = typeof data.animation_data === 'string' 
      ? JSON.parse(data.animation_data)
      : data.animation_data;
    
    const pathCount = animData.frames.reduce((count, frame) => {
      return count + (frame.script?.filter(item => item.shape === 'path').length || 0);
    }, 0);
    
    const frame2 = animData.frames.find(f => f.frameIndex === 2);
    const frame2Paths = frame2?.script?.filter(item => item.shape === 'path') || [];
    
    console.log('📊 Path Elements:', {
      total: pathCount,
      frame2: frame2Paths.length,
      frame2Sample: frame2Paths.slice(0, 2).map(p => ({
        shape: p.shape,
        hasD: !!p.parameters?.d,
        d: p.parameters?.d?.substring(0, 80) + '...'
      }))
    });
    
    if (pathCount === 0) {
      console.error('❌ PROBLEM: Database has 0 path elements!');
      console.error('   → Action: Run wysiwyg_triangle_centers_animation.sql');
    } else if (pathCount < 73) {
      console.warn(`⚠️ WARNING: Only ${pathCount} path elements (expected 73)`);
    } else {
      console.log(`✅ Database correct: ${pathCount} path elements`);
      console.log('   → If frontend shows 0, check data loading');
    }
    
    return { pathCount, frame2PathCount: frame2Paths.length };
  };
  
  console.log('💡 Debug helper available: Run window.debugAnimationData() in console');
}

// Export the client for reuse
export const getSupabaseClient = () => supabase;

export default supabase;

